import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.name}`);
      let to = location.state?.from;
      if (!to) {
        if (u.role === "admin") to = "/admin";
        else if (u.role === "owner") to = "/owner";
        else to = "/traveler";
      }
      navigate(to);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erreur");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-24 sm:pt-28 min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1753601702644-20e2d1a77fd8?w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute bottom-12 left-12 text-white max-w-md">
          <div className="text-[11px] uppercase tracking-[0.3em] mb-4 text-white/80">Degemer mat — Bienvenue</div>
          <h2 className="font-display text-4xl font-bold leading-tight">Retrouvez votre Bretagne, en un clic.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-md">
          <div className="text-[11px] uppercase tracking-[0.3em] text-neutral-500 font-bold mb-3">Connexion</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mb-8">Bon retour parmi nous</h1>

          <label className="block mb-6">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-2">Email</div>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border-b-2 border-black/20 focus:border-[#0A0A0A] outline-none py-3 bg-transparent" />
          </label>
          <label className="block mb-8">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-2">Mot de passe</div>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border-b-2 border-black/20 focus:border-[#0A0A0A] outline-none py-3 bg-transparent" />
          </label>

          <button data-testid="login-submit" type="submit" disabled={submitting} className="w-full bg-[#0A0A0A] text-white py-4 font-semibold hover:bg-[#1B2A49] transition-colors disabled:opacity-50">
            {submitting ? "Connexion…" : "Se connecter"}
          </button>

          <p className="mt-6 text-sm text-neutral-600">
            Pas encore de compte ? <Link to="/register" className="font-semibold underline underline-offset-4">Créer un compte</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
